module.exports = __webpack_public_path__ + "static/media/randomActs.ec934303.PNG";